import { useEffect, useState } from "react";
import { isInsideTelegram } from "./telegram";

const QUERY = "(min-width: 1024px)";

/**
 * Desktop layout = opened in a regular browser (NOT in Telegram) on a wide screen.
 * Inside Telegram (phone or Telegram Desktop) this is always false, so the
 * Mini App keeps its current look.
 */
export function useDesktop(): boolean {
  const [desktop, setDesktop] = useState(() => !isInsideTelegram() && typeof window !== "undefined" && window.matchMedia?.(QUERY).matches === true);
  useEffect(() => {
    if (isInsideTelegram() || !window.matchMedia) return;
    const mq = window.matchMedia(QUERY);
    const onChange = () => setDesktop(mq.matches);
    mq.addEventListener?.("change", onChange);
    return () => mq.removeEventListener?.("change", onChange);
  }, []);
  return desktop;
}
